<template>
	<section>
		<div class="container">
			<div class="error-page padd-top-30 padd-bot-30">
				<h1 class="mrg-top-15 mrg-bot-0 cl-danger font-250 font-bold" style="color:#7f44ff">404</h1>
				<h2 class="mrg-top-10 mrg-bot-5 funky-font font-60">{{ $t('notfound.missed') }}</h2>
				<p>{{ $t('notfound.not') }}</p>
				<router-link to="/" class="btn theme-btn mrg-top-20">{{ $t('notfound.go') }}</router-link>
			</div>
		</div>
	</section>
</template>
<style scoped>
.error-page {
    text-align: center;
}
.error-page p {
    font-size: 17px;
	text-transform: initial;
}
.error-page i {
    width:100px;
    height:100px;
    display: table;
    margin: 0 auto;
    background: #ffffff;
    line-height:100px;
    font-size:45px;
    color:#f21136;
	border-radius:50%;
	border: 1px solid #ffcad3;
    box-shadow:0px 0px 10px 1px rgb(255, 180, 193);
    -webkit-box-shadow:0px 0px 10px 1px rgb(255, 180, 193);
    -moz-box-shadow:0px 0px 10px 1px rgb(255, 180, 193);
}
</style>
<script>
export default {
  name: '404'
}
</script>